import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CompaniesDropdown from '../companies/companies-dropdown.jsx';

export default class AddNewPortalAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      companies: props.companiesAll || [],
      selectedCustomerId: null,
      visible: false,
    };

    this.onAddNewPortalAccountCreate = this.
      onAddNewPortalAccountCreate.bind(this);
    this.toggleAddNewPortalAccount = this.
      toggleAddNewPortalAccount.bind(this);
    this.handleFileConvert= this.
    handleFileConvert.bind(this);
  }

  handleCustomerSelection(option) {
    this.setState(
      {
        selectedCustomerId: option.id
      }
    );
  }

  toggleAddNewPortalAccount() {
    $('#add_new_portal_account_form').slideToggle();
    document.querySelector('.add-new-portal-account-button').
      classList.toggle('text-center');
    document.querySelector('.add-new-portal-account-button').
      classList.toggle('opened-button-for-slidedown-content');
    document.querySelector('#slide-toggle-icon').
      classList.toggle('fa-minus-circle');
    document.querySelector(
      '#react-component-g4-logistics-portal-customers-add-new-portal-account').
      classList.toggle('active');
  }

  handleFileConvert() {
    let uploadInput = document.getElementById('inp');

    if (uploadInput && uploadInput.files && uploadInput.files[0]) {
      let fileReader = new FileReader();
      fileReader.addEventListener("load", function(e) {
        document.getElementById("img").src = e.target.result;
        document.getElementById("b64").value = e.target.result;
      });

      fileReader.readAsDataURL(uploadInput.files[0]);
    }
    else {
      alert('sorry, error working with image');
    }
  }

  onAddNewPortalAccountCreate(e) {
    e.preventDefault();
    let newPortalAccountData = {
      api_token: window.api_token,
      company_id:  document.querySelector(
        '[name=company_id]').value,
      first_name: document.querySelector(
        '[name=portal_account_first_name]').value,
      last_name: document.querySelector(
        '[name=portal_account_last_name]').value,
      role_is_planner: document.querySelector(
        '[name=role_is_planner]:checked') !== null,
      role_is_financial: document.querySelector(
        '[name=role_is_financial]:checked') !== null,
      role_is_portal_admin: document.querySelector(
        '[name=role_is_portal_admin]:checked') !== null,
      role_is_portal_staff: document.querySelector(
        '[name=role_is_portal_staff]:checked') !== null,
      role_is_office_admin: document.querySelector(
        '[name=role_is_office_admin]:checked') !== null,  
      role_is_company_admin: document.querySelector(
        '[name=role_is_company_admin]:checked') !== null,
      email: document.querySelector(
        '[name=portal_account_login_email]').value,
      image: document.querySelector(
        '#b64').value,
      password: document.querySelector(
        '[name=portal_account_login_password]').value,
    }

    $.ajax({
      type: "POST",
      url: '/api/v1/portal/portal-admin/add-new-portal-account',
      data: newPortalAccountData,
      dataType: "text/json",
      complete: function(response) {
        if (response.status == 200) {
          document.getElementById('infomodallabel').
            innerHTML = 'New Portal Account Created';
          document.querySelector('#infomodal .modal-body').
          innerHTML = 'New Portal Account Created';
          $('#infomodal').modal();
          document.getElementsByTagName(
            'input').value = '';
          document.getElementsByTagName(
            'textarea').value = '';
        }
        else {
          document.querySelector('#infomodallabel').
            innerHTML = 'Error adding new portal account';

          $('#infomodal .modal-body').html(
            $.parseHTML(
              response.responseText.
                replace(/\"/g, "")
            ));
          $('#infomodal').modal();
        }
      }
    });
  }

  render() {
    return (
      <div>
        <button
          className="text-center btn btn-lg btn-light add-new-portal-account-button"
          type="button" onClick={this.toggleAddNewPortalAccount}>
          <i className="fa fa-plus-circle" id="slide-toggle-icon"></i>&nbsp;
            Add New Portal Account
        </button>

        <form id="add_new_portal_account_form" ref="addNewPortalAccountForm">
          <fieldset>
            <div className="row">
              <div className="col-md-12">
                <h1 className="text-center">Adding New Portal Account</h1>

                <div className="row">
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-12">
                      <label htmlFor="company_name">
                        This account belongs to the company:
                      </label>
                        <CompaniesDropdown />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="portal_account_first_name">
                          First name:
                        </label>
                        <input type="text"
                               className="form-control form-control-lg"
                               name="portal_account_first_name"
                               id="portal_account_first_name" />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="portal_account_last_name">
                          Last name:
                        </label>
                        <input type="text"
                               className="form-control form-control-lg"
                               name="portal_account_last_name"
                               id="portal_account_last_name" />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="portal_account_login_email">
                          Login email:
                        </label>
                        <input type="text"
                               className="form-control form-control-lg"
                               name="portal_account_login_email"
                               id="portal_account_login_email" />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="portal_account_login_password">
                          Login password:
                        </label>
                        <input type="text"
                               className="form-control form-control-lg"
                               name="portal_account_login_password"
                               id="portal_account_login_password" />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="roles-container">
                        <h5>Roles</h5>

                        <div className="checkbox">
                          <label> Is user a Company Admin?
                            <input type="checkbox"
                                   name="role_is_company_admin"
                                   defaultValue="true" />

                            <span className="cr">
                              <i className="cr-icon fa fa-check"></i>
                            </span>
                          </label>
                        </div>

                          <div className="checkbox">
                            <label> Is user a Job Planner?
                              <input type="checkbox"
                                name="role_is_planner"
                                defaultValue="true" />

                              <span className="cr">
                                <i className="cr-icon fa fa-check"></i>
                              </span>
                            </label>
                          </div>

                          <div className="checkbox">
                            <label> Is user a Financial?
                              <input type="checkbox"
                                name="role_is_financial"
                                defaultValue="true" />

                              <span className="cr">
                                <i className="cr-icon fa fa-check"></i>
                              </span>
                            </label>
                          </div>

                          <div className="checkbox">
                            <label> Is user a Portal Admin?
                              <input type="checkbox"
                                name="role_is_portal_admin"
                                defaultValue="true" />

                              <span className="cr">
                                <i className="cr-icon fa fa-check"></i>
                              </span>
                            </label>
                          </div>

                          <div className="checkbox">
                            <label> Is user a Portal staff?
                              <input type="checkbox"
                                name="role_is_portal_staff"
                                defaultValue="true" />

                              <span className="cr">
                                <i className="cr-icon fa fa-check"></i>
                              </span>
                            </label>
                          </div>

                          <div className="checkbox">
                            <label> Is user a Office Admin?
                              <input type="checkbox"
                                name="role_is_office_admin"
                                defaultValue="true" />

                              <span className="cr">
                                <i className="cr-icon fa fa-check"></i>
                              </span>
                            </label>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group image-upload-container">
                      <label htmlFor="portal_account_photo">
                        Account Photo
                      </label>
                      <input id="inp"
                        type='file'
                        onChange={this.handleFileConvert}
                        className="form-control" />
                      <input type="hidden"
                        name="image-base-64"
                        id="b64" />
                    </div>
                    <img id="img" />
                  </div>
                </div>
              </div>
              <div className="dropdown-form-button-container">
                <button className="btn btn-lg btn-primary"
                  onClick={this.onAddNewPortalAccountCreate}
                  type="button">
                  Add New Portal Account
                </button>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}


if (document.getElementById(
  'react-component-g4-logistics-portal-customers-add-new-portal-account')) {
  ReactDOM.render(
    <AddNewPortalAccount />, document.getElementById(
      'react-component-g4-logistics-portal-customers-add-new-portal-account'));
}
